/**
 * The pounce charge meter's element.  packages/client/src/hud.js's ChargeMeter drives
 * it entirely through classes and the --charge custom property; charge.css
 * says why it sits bottom-centre and how the fill stays a transform.
 */
import "./charge.css";
import { mount } from "./dom.js";

export function mountCharge() {
  return mount(`
<div id="charge" class="panel">
  <span>pounce</span>
  <i></i>
</div>`);
}
